import { TRoute } from "@/shared/types/route";
import MLExportsLayout from "./pages/ml-exports-layout";
import ReviewPage from "./pages/review-page";
import ExportConfigsPage from "./pages/export-configs-page";
import ExportRunsPage from "./pages/export-runs-page";
import ExportRunDetailPage from "./pages/export-run-detail-page";
import { ML_EXPORTS_URL } from "./config/ml-exports-urls";

const ML_EXPORTS_ROOT_ROUTE: TRoute = {
  name: "ML Exports",
  path: ML_EXPORTS_URL.ROOT,
  component: MLExportsLayout,
  roles: [],
  routes: [
    {
      name: "Classification Review",
      path: "review",
      component: ReviewPage,
      roles: [],
    },
    {
      name: "Export Configs",
      path: "configs",
      component: ExportConfigsPage,
      roles: [],
    },
    {
      name: "Export Runs",
      path: "runs",
      component: ExportRunsPage,
      roles: [],
    },
    {
      name: "Export Run Detail",
      path: "runs/:runId",
      component: ExportRunDetailPage,
      roles: [],
    },
  ],
};

const ML_EXPORTS_ROUTES = {
  ML_EXPORTS_ROOT_ROUTE,
} as const;

export { ML_EXPORTS_URL, ML_EXPORTS_ROUTES };
